/**
 * Helper function to download multiple resources.
 */
export const downloadArtworkResources = (
    urls: (string | null | undefined)[],
): void => {
    urls.filter((url): url is string => !!url).forEach((url, index) => {
        window.setTimeout(() => {
            const link = document.createElement('a');
            link.href = url;
            link.download = '';
            link.rel = 'noopener';
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            link.remove();
        }, index * 150);
    });
};
